<template>
  <div>
    <h1>Tax</h1>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>